import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import styles from './agenda.module.scss';
import AgendaTabMenu from './components/AgendaTabMenu.component';
import Calendar from './components/Calendar';
import { eAgendaTabs } from './components/Calendar/Calendar.enums';
import { useCalendarContext } from './components/Calendar/Calendar.hook';
import CalendarProvider from './components/Calendar/Calendar.provider';
import CreateEvent from './components/Calendar/forms/CreateEvent/CreateEvent.component';
import DeleteEvent from './components/Calendar/forms/DeleteEvent/DeleteEvent.component';
import UpdateEvent from './components/Calendar/forms/UpdateEvent/UpdateEvent.component';
import TemplateTabMenu from './components/TemplateTabMenu.component';
import TemplateManagement from './components/Templates/Templates.component';
import { AgendaTemplatesProvider } from './providers/agendaTemplates.provider';

export default function AgendaView(): React.ReactElement {
  return (
    <CalendarProvider>
      <AgendaWrapper />
    </CalendarProvider>
  );
}

function AgendaWrapper(): React.ReactElement {
  const { t } = useTranslation('agenda/agenda');
  const { currentTab, showCreateEvent, showDeleteEvent, showUpdateEvent } =
    useCalendarContext();

  const isTemplatesTab = currentTab === eAgendaTabs.TEMPLATES;

  return (
    <>
      <main className={styles.Agenda}>
        <section className={styles.Container}>
          <header className={styles.Header}>
            <h1 className={styles.HeaderTitle}>
              <img
                src="/images/agenda/calendar.icon.png"
                alt="automation"
                className={styles.Icon}
              />
              {t('agenda/agenda:main-title')}
            </h1>

            <h5 className={styles.HeaderSubtitle}>
              {t('agenda/agenda:title')}
            </h5>

            <p className={styles.HeaderExcerpt}>
              {t('agenda/agenda:description')}
            </p>
          </header>

          {isTemplatesTab ? <TemplateTabMenu /> : <AgendaTabMenu />}

          {isTemplatesTab && (
            <AgendaTemplatesProvider>
              <TemplateManagement />
            </AgendaTemplatesProvider>
          )}

          {!isTemplatesTab && <Calendar />}
        </section>
      </main>

      {showCreateEvent && createPortal(<CreateEvent />, document.body)}
      {showUpdateEvent && createPortal(<UpdateEvent />, document.body)}
      {showDeleteEvent && createPortal(<DeleteEvent />, document.body)}
    </>
  );
}
